import ConsentForm from '@/Components/forms/ConsentForm';

export default function Consent() {
    return (
        <div>
            <ConsentForm />
        </div>
    );
}
